module.exports = __webpack_public_path__ + "static/media/surat.2ad6ff07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/surat.jpg
// module id = 998
// module chunks = 0